import {bp} from '../core/namespace.js';
import {triggerRedirect} from './landing_page_redirect.js';

/*****************
 * bp.search
 */
var mapSearchButton = undefined;
var userLocation = undefined;
$.extend(true, bp, {

  search: (function () {

    var opts = {
      search_type: 'list',
      load_filters: false,
      initial_llz: null,
      mobileListViewLoaded: false,
      geo_page_map_options: null,
      is_redirect: false,
    };


    return {
      last_llz: null,  // latlongzoom of last selected city or map-panning

      init: function (custom_opts) {
        console.info("bpsearch")
        custom_opts = typeof custom_opts !== 'undefined' ? custom_opts : {};
        $.extend(true, opts, custom_opts);
        // bp.state.update_from_url(); // make sure we have a state object, triggering this later causes double ajax search
        this.last_llz = opts.initial_llz;
        //bp.searchForm.init();
        console.log('now calling geoTypeAhead.init')
        bp.geoTypeAhead.init();


        if (opts.search_type !== 'geo') {
          this.initialize_results(true);
        } else {

          //geo pages mobile
          if (bp.bootstrap.get_bootstrap_environment() !== 'lg') {
            if (opts.is_redirect) {
              bp.state.set('v', localStorage.view)
            }
            // check not map then show the list
            if (bp.state.get('v') !== 'map') {
              localStorage.view = 'list';
              $('.list-view').addClass('show');
            }
            // The save-search click handlers used to be an inline template
            // script; they are bound here now, and the desktop branch gets
            // them via reset_listeners(). Without this the mobile button on
            // geo pages has no listener at all.
            bp.search.reset_listeners_for_save_search_button();
            //desktop load show the list view
          } else {
            localStorage.view = 'map';
            opts.mobileListViewLoaded = true;
            bp.search.reset_listeners(); // then reset the listerners
          }
        }

        // TODO on mobile this is triggered by native backbutton so this is not working
        if(opts.is_redirect){
           bp.search.load_estateofffer_list_scroll_position();
        }
      },

      initial_llz: function () {
        return opts.initial_llz;
      },

      clear_search_filters: function (use_cache){
        let desktopDevice = bp.bootstrap.get_bootstrap_environment() === 'lg'
        $('#id_ami').val('').trigger('change');
        $('#id_ama').val('').trigger('change');
        $('#id_max_price').val('').trigger('change');
        $('#id_min_price').val('').trigger('change');

        document.dispatchEvent(new Event('clearPriceFilters'));
        
        if (desktopDevice) {
          $("#search_data")[0].reset();
        }
        $("#id_ups").val('default');
        $("#id_ups").selectpicker("refresh");

        bp.state.history_push({
          ami: '',
          ama: '',
          max_price: '',
          min_price: '',
          ups: '',
          q: '',
          cn: '',
          address: '',
          search_mode: ''
        });

        bp.search.reset_listeners_for_keyword_field();
        bp.search.reset_shapes_after_search();
        bp.search.reset_listeners_for_save_search_button();
        bp.search.reset_listeners_for_statechange();
        bp.search.reset_listeners_for_delete_saved_search();
        bp.search.reset_listeners_for_ad_snippet_xs_click();


        bp.maps.load_markers(use_cache);
      },


      clear_search_filters_modal: function (use_cache){
        //Reset form
        $("#search_data_modal")[0].reset();

        //Find id_ups elements inside search_data_modal
        var selectedList = $("#search_data_modal .selectpicker");

        //Refresh id_ups
        selectedList.val('default');
        selectedList.selectpicker("refresh");

        bp.search.reset_listeners_for_statechange();

        bp.maps.load_markers(use_cache);
      },


      reset_listeners: function () {
        var timeoutID;
        var city_field = $('.form-search-estate #id_cn');
        var modal_city_field = $('.search-modal #id_cn');
        var mobile_city_field = $('.search-box-wrapper #id_cn');
        var modal_user_display = $('.search-modal #id_user_display');
        var mobile_user_display = $('.search-box-wrapper #id_user_display');
        bp.search.reset_listeners_for_city_field(city_field);
        // reset listeners for modal and search bar fields on mobile
        //set the modal search field to the city
        if (bp.bootstrap.get_bootstrap_environment() !== 'lg') {
          bp.search.reset_listeners_for_city_field(modal_city_field);
          bp.search.reset_listeners_for_city_field(mobile_city_field);
          modal_city_field.blur()
          mobile_city_field.blur()
          //modal_user_display.blur()
          //mobile_user_display.blur()
        }


        bp.search.reset_listeners_for_keyword_field();
        bp.search.reset_shapes_after_search();
        bp.search.reset_listeners_for_save_search_button();
        bp.search.reset_listeners_for_statechange();
        bp.search.reset_listeners_for_delete_saved_search();
        bp.search.reset_listeners_for_ad_snippet_xs_click();
        bp.search.reset_listeners_for_filters();
        bp.search.reset_listeners_for_auto_refresh_filters();
        bp.search.reset_listeners_for_hx_pagination();

        // enter on city field is submit
        $("#id_user_display").on('keydown', function (e) {
          if (e.keyCode === 13) {
            if ($("#id_user_display").val() === '') {
              // only clear zoom if enter pressed on city field
              bp.maps.jump_to_llz('52,5.8,7')
            }
            // bp.search.hx_search(e)
            // dont trigger search?
          }
        });
      },

      reset_listeners_for_filters: function () {
        $(".js-filter").off('click');
        $(".js-filter").on('click', function (e) {
            e.preventDefault();
            var el = $(this);
            var statekey = el.data('statekey');
            var statevalue = String(el.data('statevalue'));
            var selectedLabel = $.trim(el.text());
            var triggerPagination = bp.search.hx_search_pagination;

            var allFilters = $('.js-filter[data-statekey="' + statekey + '"]');
            allFilters.closest('li').removeClass('active');
            allFilters.filter('[data-statevalue="' + statevalue + '"]').closest('li').addClass('active');

            // Only sort links may rewrite the "Sorteren: <label>" buttons —
            // pagination links are .js-filter too (statekey "p") and wrote
            // "Sorteren: 2" here. The modal button lives in
            // #search_data_modal; .search-modal is a sibling wrapper class
            // that is not an ancestor of the sort dropdown.
            if (statekey === 'srt') {
                $('#sort_btn .dropdown-toggle strong').text(selectedLabel);
                $('#search_data_modal .dropdown-toggle.sorteren strong').text(selectedLabel);
                // The trigger is compact again (label visually hidden); keep the
                // full selection readable via the tooltip.
                $('#sort_btn .dropdown-toggle, #search_data_modal .dropdown-toggle.sorteren')
                    .attr('title', 'Sorteren: ' + selectedLabel);
            }

            var url = new URL(window.location);
            url.searchParams.set(statekey, statevalue);
            window.history.replaceState({}, '', url);

            if ($('#search-form-modal').hasClass('in')) {
                $('#search-form-modal').modal('hide');
            }

            var page = (statekey === 'p') ? parseInt(statevalue, 10) : 1;
            bp.search.hx_search_pagination(page, bp.search.get_vastgoed_slug());
        });
      },

      reset_listeners_for_auto_refresh_filters: function () {
        // BPCOM-1090: auto-refresh search when users adjust filter controls,
        // so the "Zoeken" button is no longer required on the desktop form.
        // Ported from the pre-bundle bp.js (PR #1342) and adapted to the
        // current Alpine-driven filter form (#search_data / #search_data_modal).
        // The unified place/address field (#id_user_display) is intentionally
        // excluded: it has its own typeahead/jump flow.
        //
        // BPCOM-1716: bound once, delegated on document, and attached at
        // DOM-ready (see the module-level ready handler below). Previously
        // the handlers were rebound directly on the forms only after
        // bp.search.init -> map init had run, so a filter change made in
        // that window (e.g. right after page load) was silently lost and
        // the user had to repeat the same action.
        if (this._autoRefreshFiltersBound) {
          return;
        }

        var forms = ['#search_data', '#search_data_modal'];
        var immediateFields = [
          'select[name="tt"]',
          'input[name="price_type"]',
          'input[name="inv"]'
        ];
        var debouncedFields = [
          'input[name="min_price"]',
          'input[name="max_price"]',
          'input[name="ami"]',
          'input[name="ama"]'
        ];
        var buildSelector = function (fields) {
          var parts = [];
          forms.forEach(function (form) {
            fields.forEach(function (field) {
              parts.push(form + ' ' + field);
            });
          });
          return parts.join(', ');
        };
        // The homepage hero form reuses id="search_data"; only auto-refresh
        // on pages that actually have the htmx results list.
        var onSearchPage = function () {
          return document.getElementById('estateListHx') !== null;
        };

        $(document).on('change.bpAutoRefresh', buildSelector(immediateFields), function () {
          if (!onSearchPage()) {
            return;
          }
          // BPCOM-1717: clear stale price criteria before the search runs so
          // rent/sale/both modes never keep a previous mode's min/max.
          // Sync tt onto the store AND both form copies first. Desktop and
          // the modal each render a select[name=tt]; Alpine 3.8 two-way
          // x-model on both wrote the previous value back onto the one the
          // user just changed (first click stayed "Te huur en te koop").
          if (this.name === 'tt' && window.Alpine && Alpine.store('filters')) {
            var ttVal = String(this.value);
            Alpine.store('filters').tt = ttVal;
            $('#search_data, #search_data_modal').find('select[name="tt"]').val(ttVal);
            Alpine.store('filters').changeView();
          }
          bp.search.schedule_auto_refresh_search(true);
        });

        $(document).on('input.bpAutoRefresh', buildSelector(debouncedFields), function () {
          if (!onSearchPage()) {
            return;
          }
          bp.search.schedule_auto_refresh_search(false);
        });

        // Bootstrap-select (Gebruiksdoel / ups) emits a custom changed event.
        $(document).on('changed.bs.select.bpAutoRefresh', '#search_data .selectpicker, #search_data_modal .selectpicker', function () {
          if (!onSearchPage()) {
            return;
          }
          bp.search.schedule_auto_refresh_search(true);
        });

        this._autoRefreshFiltersBound = true;
      },

      schedule_auto_refresh_search: function (immediate) {
        if (bp.search._autoRefreshTimeout) {
          clearTimeout(bp.search._autoRefreshTimeout);
        }

        // BPCOM-1716: on desktop (and mobile map view) hx_search needs the
        // map and its initial marker/list load to be finished. A filter
        // change made before that used to be swallowed: the search either
        // crashed on the uninitialised map or reused the stale page-load
        // snapshot (maps opts.data_url / list_loaded), so only a second
        // identical change had any effect. Wait for the initial load and
        // then search with the live form state. Bounded so a page where the
        // map never loads (e.g. blocked scripts) does not retry forever.
        var maxMapReadinessRetries = 40; // 40 * 500ms = 20s
        var triggerSearch = function (attempt) {
          var needsMap = bp.bootstrap.get_bootstrap_environment() === 'lg'
            || localStorage.view === 'map';
          if (needsMap && (bp.maps === undefined || !bp.maps.isLoaded())) {
            // BPCOM-1688: the list no longer depends on the map (hx_search
            // refreshes it directly), so show the filtered results NOW.
            // Geo pages often have no loaded map (list view, consent gate);
            // waiting the full retry window made the first change look dead.
            // The map keeps waiting below and refreshes its markers when it
            // becomes ready.
            if (attempt === 0) {
              bp.search.hx_search_pagination(1, bp.search.get_vastgoed_slug());
            }
            if (attempt < maxMapReadinessRetries) {
              bp.search._autoRefreshTimeout = setTimeout(function () {
                triggerSearch(attempt + 1);
              }, 500);
              return;
            }
            // Map never became ready (blocked script, consent gate). The
            // list was already refreshed at attempt 0; nothing left to do.
            return;
          }
          bp.search.hx_search({
            preventDefault: function () {},
            fromAutoRefresh: true
          });
        };

        if (immediate) {
          triggerSearch(0);
          return;
        }

        bp.search._autoRefreshTimeout = setTimeout(function () {
          triggerSearch(0);
        }, 350);
      },

      show_auto_refresh_indicator: function () {
        $('#search-auto-refresh-indicator').stop(true, true).fadeIn(120);

        if (bp.search._autoRefreshIndicatorTimeout) {
          clearTimeout(bp.search._autoRefreshIndicatorTimeout);
        }

        // Fallback to avoid a stuck indicator if a request aborts.
        bp.search._autoRefreshIndicatorTimeout = setTimeout(function () {
          bp.search.hide_auto_refresh_indicator();
        }, 3000);
      },

      hide_auto_refresh_indicator: function () {
        $('#search-auto-refresh-indicator').stop(true, true).fadeOut(120);
        if (bp.search._autoRefreshIndicatorTimeout) {
          clearTimeout(bp.search._autoRefreshIndicatorTimeout);
          bp.search._autoRefreshIndicatorTimeout = null;
        }
      },

      reset_listeners_for_hx_pagination: function () {
        if (this._hxPaginationBound) {
          return;
        }

        $(document).on('click', '[data-hx-search-pagination]', function (event) {
          // On geo (block) pages we paginate the geo page itself via htmx so
          // the breadcrumbs, intro blocks, SEO content and map stay intact.
          // The generic /zoeken/ pagination path is destructive there (it
          // rewrites the URL to /zoeken/ and strips the geo page extensions),
          // so route geo pages through a dedicated, non-destructive handler.
          if (bp.search.is_geo_pagination_link(this)) {
            bp.search.hx_geo_pagination(this, event);
            return;
          }

          const page = parseInt($(this).data('page'), 10);
          const vastgoedSlug = $(this).data('vastgoed-slug') || '';
          bp.search.hx_search_pagination(page, vastgoedSlug, event);
        });

        this._hxPaginationBound = true;
      },

      is_geo_pagination_link: function (link) {
        if (!document.body.classList.contains('geopages')) {
          return false;
        }
        try {
          const url = new URL(link.getAttribute('href'), window.location.origin);
          return url.pathname !== '/zoeken/';
        } catch (e) {
          console.debug('is_geo_pagination_link failed', e);
          return false;
        }
      },

      hx_geo_pagination: function (link, event) {
        /**
         * HTMX pagination for geo (block) pages.
         * Loads the requested page of results into #estateListHx from the geo
         * page's own URL, keeping the page (breadcrumbs, intro blocks, map and
         * markers) intact. Unlike hx_search_pagination it does NOT redirect to
         * /zoeken/ or strip the geo page extensions.
         **/
        if (event && typeof event.preventDefault === 'function') {
          event.preventDefault();
        }

        if (window.searchHtmxInprogress === true) {
          console.debug('geo pagination htmx in progress, skipping click');
          return;
        }

        const href = link.getAttribute('href');
        if (!href) {
          return;
        }

        if (typeof htmx === 'undefined') {
          // No htmx available, fall back to a normal navigation
          window.location.href = href;
          return;
        }

        try {
          htmx.ajax('GET', href, {
            target: '#estateListHx',
            swap: 'innerHTML',
          });

          // Keep the address bar in sync without rewriting the geo path to
          // /zoeken/. The href is the clean, crawlable geo URL (e.g. ?p=2).
          window.history.pushState({}, '', href);
        } catch (e) {
          console.debug('geo pagination failed, falling back to navigation', e);
          window.location.href = href;
        }
      },

      reset_listeners_for_city_field: function (city_field) {
        console.log('reset_listeners_for_city_field', city_field)

        // Remove existing listeners (to prevent double triggers)
        city_field.off("typeahead:selected typeahead:autocompleted focus change blur");

        // Set listeners
        city_field.on('typeahead:selected typeahead:autocompleted', function (e, item_data) {

          bp.maps.remove_shapes_and_movements_after_search()

          if (item_data && item_data.result === 'nomatch') {
            // Best match function could not find a match, clear the field
            city_field.val('Niet gevonden');
            setTimeout(function () { city_field.val(''); }, 500);
            return;
          }

          // Normalize selection type
          var isAddress = item_data && item_data.type === 'address';
          var isCity = item_data && item_data.type === 'city';

          // Persist mode and form values
          // Parse a city token to keep in state/URL when an address is chosen
          var cityForAddress = (item_data && item_data.city)
            ? item_data.city
            : ((item_data && item_data.value) ? item_data.value.split(',').slice(-1)[0].trim() : '');

          if (isAddress) {
            $('#id_search_mode').val('address');
            if (bp.state && bp.state.set) bp.state.set('search_mode', 'address');

            // Display the address string in the visible field
            var fullAddress = item_data.address || item_data.value || '';
            $('#id_cn').val(fullAddress);

            // Keep city token in state for backend filtering and URL (cn)
            if (bp.state && bp.state.set) bp.state.set('cn', cityForAddress);

            // Post full address as hidden field
            $('#id_address').val(fullAddress);
            if (bp.state && bp.state.set) bp.state.set('address', fullAddress);
          } else if (isCity) {
            $('#id_search_mode').val('city');
            if (bp.state && bp.state.set) bp.state.set('search_mode', 'city');

            $('#id_address').val('');
            if (bp.state && bp.state.set) bp.state.set('address', '');

            $('#id_cn').val(item_data.value);
            if (bp.state && bp.state.set) bp.state.set('cn', item_data.value);
          }

          // let other listeners know that the city has been selected
          window.dispatchEvent(new CustomEvent('cityfieldchanged'));

          $(this).data('no-selection-made', false);

          // update llz and move map
          var llz = item_data && item_data.llz ? item_data.llz
                    : (item_data && item_data.lat && item_data.lng ? [item_data.lat, item_data.lng, 14].join(',') : null);
          if (llz) {
            bp.search.last_llz = llz;
            $("#id_llz").val(llz)
            $("#id_llz_mb").val(llz)
            bp.maps.jump_to_llz(llz);
          }

          // Trigger search
          if (bp.bootstrap.get_bootstrap_environment() !== 'lg') {
            if (localStorage.view === 'map') {
              bp.search.map_search(true)
            } else {
              // For address mode push city token in cn (URL), not the displayed address string
              var pushCn = isAddress
                ? (cityForAddress)
                : (item_data && item_data.value);
              if (pushCn) bp.state.history_push({'cn': pushCn});
              bp.search.hx_search_pagination()
            }
          } else {
            // desktop
            var pushCn2 = isAddress
              ? (cityForAddress)
              : (item_data && item_data.value);
            console.log('pushCn2', pushCn2)
            if (pushCn2) bp.state.history_push({'cn': pushCn2});
            // we dont have to call hx will be call on desktop
          }

        }).on('focus', function (e) {
          $(this).data('no-selection-made', true);
          $(this).data('changed', false);

        }).on('change', function (e) {
          $(this).data('changed', true);


        }).on('blur', function (e) {
          setTimeout(function () {
            if (city_field.data('no-selection-made') === true && city_field.data('changed') === true) {
              if (city_field.val() !== '') {
                // The city field lost focus with unresolved content, let's try a best match to resolve the city
                $.getJSON('/data/bestmatch_city.json?q=' + city_field.val(), {}, function (result) {
                  city_field.trigger('typeahead:autocompleted', result);
                });
              } else {
                // The city field lost focus and is empty, let's reset some state variables and leave it
                city_field.data('no-selection-made', false);
                city_field.data('changed', false);
              }
            }
          }, 500);

        });
      },

      /**
       * Sync location from URL state into the search form, then open save-search.
       * Used by the empty-results "Ja, houd mij op de hoogte" CTA.
       */
      open_save_search_from_empty_results: function () {
        var cn = bp.state.get('cn');
        if (cn && !$('#id_cn').val()) {
          $('#id_cn').val(cn);
          $('#search-form-modal #id_cn').val(cn);
        }
        var is_mobile = bp.bootstrap.get_bootstrap_environment() !== 'lg';
        if (is_mobile) {
          bp.search.copy_modal_search_form_to_state();
        } else {
          bp.search.copy_search_form_to_state();
        }
        bp.search.open_save_search_modal(is_mobile ? '#mobile-save-search-button' : '#save-search-button');
      },

      /**
       * Opens the save-search modal for the current form state.
       *
       * The modal endpoint decides what to render: the save form for logged-in
       * users, a login prompt otherwise. The button's data-href is never
       * rewritten, so repeated clicks cannot accumulate query strings.
       */
      open_save_search_modal: function (selector) {
        var base_href = $(selector).attr('data-href');
        if (!base_href) {
          return;
        }
        $('#modal').modal({remote: base_href + '?' + bp.state.get_full_url()});
      },

      reset_listeners_for_save_search_button: function () {

        // Remove existing listeners (to prevent double triggers)
        $("#save-search-button").off('click');
        $("#mobile-save-search-button").off('click');

        $('#save-search-button').on('click', function (e) {
          e.preventDefault();
          bp.search.copy_search_form_to_state();
          bp.search.open_save_search_modal('#save-search-button');
        });

        $('#mobile-save-search-button').on('click', function (e) {
          e.preventDefault();
          bp.search.copy_search_form_to_state();
          bp.search.open_save_search_modal('#mobile-save-search-button');
        });
      },

      triggerStatechange: function () {


        if (bp.state.value_changed('llz')) {
          bp.search.map_search(true); // search with local cache enabled
        } else {
          bp.search.reset_filter();
          bp.search.map_search(false);
          var __disp = (bp.state.get('search_mode') === 'address' && bp.state.get('address')) ? bp.state.get('address') : (bp.state.get('cn') || '');
          $('#id_user_display').val(__disp)
          $('.search-modal #id_user_display').val(__disp)
          $('#id_cn').val(bp.state.get('cn') || '')
        }
      },

      reset_listeners_for_statechange: function () {
        // Updating the search form, a search-filter or results in a bp-statechange event
        // This triggers the actual search results to be updated

        // Remove existing listeners (to prevent double triggers)
        $(window).off('bp-statechange');

        $(window).on('bp-statechange', function () {
          bp.search.triggerStatechange()
        });
      },

      reset_listeners_for_keyword_field: function () {
        $("#id_q").on('keydown', function (e) {
          if (e.keyCode === 13) {
            $('.refresh-search').trigger('click');
            e.preventDefault();
          }
        });
      },

      reset_shapes_after_search: function () {
        $('.refresh-search').on('click', function(e){
          bp.maps.remove_shapes_and_movements_after_search()
        })
      },

      reset_listeners_for_delete_saved_search: function () {
        $('.remove-saved-search').off().click(function (e) {
          e.preventDefault();
          if (confirm('Weet u zeker dat u deze zoekopdracht wilt verwijderen?\n\nU ontvangt dan ook geen e-mail notificaties meer.')) {
            var tablerow = $(this);
            $.post($(this).attr('href'), function (data) {
              tablerow.closest('li').fadeOut(500, function () {
                $().remove(this);
              });
            });
          }
          var saved_searches = document.querySelector('.list-saved-searches').childNodes;
          var number_of_saved_searches = 0;

          Array.prototype.forEach.call(saved_searches, function (item) {
            if (item.nodeName === 'LI') {
              if (item.style.cssText !== "display: none;") {
                ++number_of_saved_searches
              }
            }
          });
          if (number_of_saved_searches === 0) {
            $('.saved-searches').remove()
          }
        });
        $('#id_saved_search').change(function (e) {
          document.location.href = $(this).val();
        });
      },

      reset_listeners_for_ad_snippet_xs_click: function () {
        $('#ad-snippet-xs').click(function (e) {
          if (!e.target.classList.contains('fa-heart') && !e.target.classList.contains('btn')) {
            document.location = $(this).find('h3 a').attr('href');
          }
        });
      },

      /**
       * reset_filter
       *
       * copies bp.state values to the search form
       */
      reset_filter: function () {
        var searchMode = bp.state.get('search_mode') || 'city';
        var addressVal = bp.state.get('address') || '';
        // Display address when in address mode, else city
        var displayValue = (searchMode === 'address' && addressVal) ? addressVal : (bp.state.get('cn') || '');
        // BPCOM-1716: fall back to '3' (Te huur en te koop), the backend
        // default, instead of blanking the tt select (selectedIndex -1) when
        // tt is absent from the URL/state.
        var ttValue = String(bp.state.get('tt') || '3');
        $('#id_user_display').val(displayValue);
        // Sync hidden fields for initial load
        $('#id_search_mode').val(searchMode);
        $('#id_address').val(addressVal);
        $('#id_cn').val(bp.state.get('cn') || '');
        $('#id_r').val(bp.state.get('r'));
        $('#id_up').val(bp.state.get('up'));
        // Duplicate id_tt on desktop + modal: set every copy by name.
        $('#search_data, #search_data_modal').find('select[name="tt"]').val(ttValue);
        // BPCOM-1732: these ids are duplicated on desktop + mobile. An id
        // selector would only update the first copy; Alpine x-model would
        // then write the store value onto both and can clobber a focused
        // field. Set every copy by name, and never pass null into number inputs.
        var amiValue = bp.state.get('ami') || '';
        var amaValue = bp.state.get('ama') || '';
        var minPrice = bp.state.get('min_price') || '';
        var maxPrice = bp.state.get('max_price') || '';
        $('#search_data, #search_data_modal')
          .find('input[name="ami"]').val(amiValue);
        $('#search_data, #search_data_modal')
          .find('input[name="ama"]').val(amaValue);
        $('#search_data, #search_data_modal')
          .find('input[name="min_price"]').val(minPrice);
        $('#search_data, #search_data_modal')
          .find('input[name="max_price"]').val(maxPrice);
        $('#id_q').val(bp.state.get('q'));

        // BPCOM-1718: restore Gebruiksdoel multi-select from CSV `ups` state —
        // but only when `ups` is actually present. On /plaats/<city>/<useplan>/
        // pages the preselection comes from the form initial, not the URL, and
        // applying an empty array here would wipe it on the first statechange.
        var upsState = bp.state.get('ups');
        if (upsState !== undefined && upsState !== null && String(upsState) !== '') {
          var upsValues = String(upsState).split(',').map(function (v) { return v.trim(); }).filter(Boolean);
          var $ups = $('#id_ups');
          if ($ups.length) {
            $ups.val(upsValues);
            if ($ups.selectpicker) {
              $ups.selectpicker('val', upsValues);
              $ups.selectpicker('refresh');
            }
          }
        }

        // BPCOM-1716: keep the Alpine filters store in sync with the form.
        // The tt selects and the price/oppervlakte inputs are x-model bound,
        // so updating only the DOM values above would leave the store (and
        // the filter-bar button labels) stale.
        if (window.Alpine !== undefined && Alpine.store('filters') !== undefined) {
          var filters = Alpine.store('filters');
          filters.tt = ttValue;
          // BPCOM-1732: '' not null — Alpine 3.8 x-model writes null onto
          // type=number and Chromium/Edge drops the first keystroke.
          filters.min = minPrice;
          filters.max = maxPrice;
          filters.ami = amiValue;
          filters.ama = amaValue;
        }
      },

      /**
       * Copies the searchform (modal-search from on mobile/tablet) values to bp.state causing
       *  - url / history change (back / forward btn functionality)
       *  - statechanged trigger (which triggers a search)
       */
      copy_search_form_to_state: function () {
        var ups = $('#search_data .selectpicker').selectpicker().val();
        if ($.isArray(ups)) {
          ups = ups.join(',');
        }
        bp.state.history_push({
          cn: $('#id_cn').val(),
          r: $('#id_r').val(),
          up: $('#id_up').val(),
          ups: ups || '',
          tt: $('#id_tt').val(),
          ami: $('#id_ami').val(),
          ama: $('#id_ama').val(),
          q: $('#id_q').val(),
          p: '', // when changing search parameters return to page 1
          max_price: $('#id_max_price').val(),
          min_price: $('#id_min_price').val(),
          price_type: $('input[name="price_type"]:checked').val(),
        });
      },

      copy_modal_search_form_to_state: function () {
        bp.state.history_push({
          cn: $('.search-modal #id_cn').val(),
          up: $('select#id_up')[1].value,
          tt: $('select#id_tt')[1].value,
          ami: $('select#id_ami')[1].value,
          ama: $('select#id_ama')[1].value,
          p: '' // when changing search parameters return to page 1
        });
      },


      getLocationForUser: function () {
        return new Promise(function (resolve, reject) {
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
              function (position) {
                const pos = {
                  latitude: position.coords.latitude,
                  longitude: position.coords.longitude,
                  zoom: 11
                };

                $.getJSON(`/in_nl_check/${pos.longitude}/${pos.latitude}/`,
                  function (result) {
                    if (result["response"] === true) {
                      userLocation = pos;
                      resolve(pos)
                    } else {
                      reject('user not in nl not setting position')
                    }
                  }).fail(function () {
                  reject('location request failed')
                })
              },
              () => {
                reject('location failed')
              }
            );
          } else {
            reject("Navigator not enabled");
          }
        });
      },


      /**
       * Used for maps initialization, tries to get state.llz and transofrm it into lat, long, zoom
       * @returns {object} latitude, longitude and zoom or empty object
       */
      get_latlongzoom: function () {
        const cn = bp.state.get("cn");
        const emptyBoundsValues = [undefined, ""]

        // first we use bounds
        const source = (!emptyBoundsValues.includes(bp.state.get('llz')) ? bp.state.get('llz') : undefined);
        if (source !== undefined) {
          return {
            latitude: parseFloat(source.split(',')[0]),
            longitude: parseFloat(source.split(',')[1]),
            zoom: parseFloat(source.split(',')[2])
          }
        } else {
          // then we check if city location is bounds
          if (cn === "") {
            if (userLocation !== undefined) {
              return userLocation
            }
          }
          // all other cases
          return {}
        }
      },

      /**
       * Initialises search/map page on non geo type pages
       * **/

      initialize_results: async function (first_load) {
        // on geo type pages we do not search just set listeners on form

        first_load = first_load && typeof first_load === 'boolean';
        if (!first_load) {
          // if not first load then remove all children and reload the list
          $('#search-results-map').children().remove();
          $('#search-results-list').children().remove();
        }

        // on mobile
        if (bp.bootstrap.get_bootstrap_environment() !== 'lg') {


          // If this is a redirect from the detail page, get page state from local storage
          if (opts.is_redirect) {
            localStorage.is_redirect = true;
            bp.state.set('v', localStorage.view)
            localStorage.removeItem('view');
          }

          /**
           * Map view on mobile
           * **/
          if (bp.state.get('v') === 'map' || bp.state.get('v') === '') {
            // show map wrapper and reset listers
            this.map_css()
            localStorage.view = 'map';

            bp.search.reset_listeners(); // then reset the listerners

            //call init map if not on geopages
            if (opts.search_type !== 'geo') {
              bp.maps.init($.extend({
                load_markers_callback: bp.search.map_search,
                data_url: bp.state.get_full_url(),
              }, this.get_latlongzoom()));
            }

            if (bp.search.last_llz) {
              bp.maps.jump_to_llz(bp.search.last_llz)
            } // Jump to llz if supplied
          } else {
            // already has estates loaded
            $('.list-view').addClass('show');
            localStorage.view = 'list';
            $('#secondary-navbar').addClass("hide-on-list-view")
            bp.search.reset_listeners(); // set up filter event listeners for list view
          }

          //desktop
        } else {
          console.info("search on desktop")

          this.getLocationForUser().catch(function (e) {
            console.debug(e, "Location request error")
          });
          const latlng = this.get_latlongzoom()

          // call init map if not on geopages
          if (opts.search_type !== 'geo') {
            // Sync hidden fields from URL/state before first markers URL is built
            bp.search.reset_filter();
            bp.maps.init($.extend({
              load_markers_callback: bp.search.map_search,
              data_url: bp.state.get_full_url(),
              list_loaded: true,
            }, latlng));
          }

          if (bp.search.last_llz) {
            bp.maps.jump_to_llz(bp.search.last_llz)
          } // Jump to llz if supplied
          bp.search.reset_listeners(); // then reset the listerners

        }

      },

      /**
       * Map load called on geo pages
       * Desktop: init map immediately on first load
       * Mobile: init map if its the first time map is loaded switch to map view
       * State: if redirected state is initialise
       * **/
      load_geopages_map: function (options) {
        //save initial llz
        if (options !== undefined) {
          opts.geo_page_map_options = options;
        }
        if (options.is_redirect) {
          localStorage.is_redirect = true;

          bp.state.set('v', localStorage.view)
          localStorage.removeItem('view');
        }
        if (!bp.maps.isLoaded()) {
          if (bp.bootstrap.get_bootstrap_environment() !== 'lg' && bp.state.get('v') === 'map') {

            $('body').addClass('show-map');


            //extend with correct data url on mobile
            if (opts.search_type !== 'geo' && opts.geo_page_map_options.map_style !== "estate_profile") {
              // todo check why we need this? if it is calling from the same url?
              opts.geo_page_map_options.data_url = bp.state.get_full_url()
              if (window.initial_llz !== undefined) {
                console.debug("initial llz supplied")
                var llz = window.initial_llz
                opts.geo_page_map_options.latitude = parseFloat(llz.split(',')[0]);
                opts.geo_page_map_options.longitude = parseFloat(llz.split(',')[1]);
                opts.geo_page_map_options.zoom = parseInt(llz.split(',')[2]);
              }
            }

            bp.maps.init(opts.geo_page_map_options);

            //on business park pages draw the polygon after init map
            bp.maps.showCurrentBusinessPark()
          } else if ((bp.bootstrap.get_bootstrap_environment() === 'lg')) {
            console.debug("load geo pages map")
            options.list_loaded = true;
            bp.maps.init((options))
          }
        }
      },


      search: function () {
        this[opts.search_type + '_search']();
      },

      map_search: function (use_cache) {
        console.debug("call back called, map_search", bp.maps.isLoaded())
          use_cache = use_cache && typeof use_cache === 'boolean';
          // if the view NOT list on mobile then add show-map
          bp.maps.load_markers(use_cache);
          bp.search.reset_listeners();
      },

      open_detail_page_from_map: function (e) {
        var target = event.target ? event.target : event.srcElement;
        if (target.classList.contains('fa-heart') || target.classList.contains('fa-heart')) {
          return false
        }

        var href = $('.infowindow-inner').find('a').attr("href");
        // on mobile, open in same tab
        if (bp.bootstrap.get_bootstrap_environment() !== 'lg') {
          window.location.href = href;
          return false
        }

        window.open(href);
        return false;
      },


      // open detail page when picture is clicked on mobile
      open_detail_page_from_map_mobile: function (e) {
        this.update_map_marker_state()

        const url = window.location.pathname + window.location.search;
        $.ajax({
          method: 'POST',
          url: '/update_session_url/',
          data: {url: url},
        });
      },

      update_map_marker_state: function () {

        const marker = bp.maps.activeMarker;
        // save the marker data to the dom
        var newMarker = {lat: marker.position.lat(), lng: marker.position.lng(), object_pk: marker.object_pk};
        localStorage.view = "map"
        localStorage.mapMarker = JSON.stringify(newMarker);
      },


      /**
       * Mobile only switch between map and list view
       * **/
      switch_to_map: function () {
        bp.state.set('v', 'map');
        localStorage.view = 'map';

        let mobile_city_field = $('.search-box-wrapper #id_cn');
        bp.search.reset_listeners_for_city_field(mobile_city_field);

        this.map_css()

        let options;
        if (opts.geo_page_map_options === null) {
          options = {}
        } else {
          options = opts.geo_page_map_options;
        }
        options.is_redirect = false;
        bp.search.load_geopages_map(options);
      },

      map_css: function () {
        $('#btn_search_map').html('<i class="fa fa-list"></i><span>Lijst</span>');
        $('body').addClass('show-map');
        $('.list-view').removeClass('show');
        $('#search-results-map').css('display', 'block');

        // search filter box
        $('#secondary-navbar').removeClass("hide-on-list-view")
      },

      switch_to_list: function () {
        bp.state.set('v', 'list');
        localStorage.view = 'list';
        localStorage.mapMarker = undefined;
        this.list_css()
        // on non geo pages list view always needs reload on switch

        if (!opts.mobileListViewLoaded) {
          opts.mobileListViewLoaded = true // only called on first load
        }
        // ajax list search
        $('#search-results-map').css('display', 'none');

        bp.search.lazy_load_images();
        //fix bug on vastgoedprofile pages on mobile
        bp.common.hide_loading_notification();
      },

      list_css: function () {
        $('.list-view').addClass('show');
        $('#btn_search_map').html('<i class="fa fa-map"></i><span>&nbsp;Kaart</span>');
        $('body').removeClass('show-map'); // hide the map
        $('#secondary-navbar').addClass("hide-on-list-view")
      },

      get_vastgoed_slug: function () {
        const vgdInput = document.getElementById('id_vgd');
        if (vgdInput && vgdInput.value) {
          return vgdInput.value;
        }

        const parts = window.location.pathname.split('/').filter(function (part) {
          return part !== '';
        });
        if (parts[0] === 'vastgoed' && parts[1]) {
          return parts[1];
        }
        return '';
      },

      search_form_state: function() {
        /**
         * Retrieve serialized data from search form
         * TODO future alpinejs better for this
         * **/
          let desktopDevice = bp.bootstrap.get_bootstrap_environment() === 'lg'
          let formId = desktopDevice ? 'search_data' : 'search_data_modal'
          let data = {}
          const form = document.getElementById(formId)
          const formData = new FormData(form)
          formData.forEach(function(value, key){
              data[key] = value;
          });

          const vastgoedSlug = bp.search.get_vastgoed_slug();
          if (vastgoedSlug) {
            data.vgd = vastgoedSlug;
          }


          let ups = desktopDevice ? $('#search_data .selectpicker').selectpicker().val() : $('#search_data_modal .selectpicker').selectpicker().val()
          if(![null, undefined, []].includes(ups)){
            data.ups = ups
          }
          // inv and mts done
          $('#id_inv').prop('checked') ? data.inv = true : data.inv = false
          $('#id_mts').prop('checked') ? data.mts = true : data.mts = false

          const urlParams = new URLSearchParams(window.location.search);
          const sortParam = urlParams.get('srt');
          if (sortParam) {
              data.srt = sortParam;
          } else {
              // Get the sort value from the active dropdown item as fallback
              const activeSortItem = $('#sort_btn .dropdown-menu li.active button');
              if (activeSortItem.length) {
                  data.srt = activeSortItem.data('statevalue');
              } else {
                  data.srt = 'default'; // Recommended default sort option
              }
          }

          // BPCOM-1717: price filter is not applicable for "Te huur en te koop".
          // Omit stale values so Zoeken / auto-refresh never send them.
          if (String(data.tt) === '3') {
            delete data.min_price;
            delete data.max_price;
            delete data.price_type;
          }

          window.searchState = data
          return data
      },

      // Normalize and compare helper for city names
      normalizeCityName: function (value) {
        if (value === undefined || value === null) { return '' }
        return String(value).trim().toLowerCase();
      },

      // Current city on geo page
      getCurrentGeoCity: function () {
        try {
          if (!document.body.classList.contains('geopages')) { return '' }
          var cnInput = document.getElementById('id_cn');
          if (cnInput && cnInput.value) { return cnInput.value }
          var bcCity = document.querySelector('.bc_geo .bc_cn, .bc_cn');
          if (bcCity && bcCity.textContent) { return bcCity.textContent.trim() }
          var parts = window.location.pathname.split('/').filter(function (p) { return p !== '' });
          var idx = parts.indexOf('plaats');
          if (idx >= 0 && parts[idx + 1]) { return decodeURIComponent(parts[idx + 1]).replace(/-/g, ' ') }
          if (parts.length > 0) { return decodeURIComponent(parts[parts.length - 1]).replace(/-/g, ' ') }
        } catch (e) { console.debug('getCurrentGeoCity failed', e) }
        return ''
      },

      // Extract intended search city from params
      extractCityFromParams: function (params) {
        try {
          if (params && params.cn) { return params.cn }
          if (params && params.address) {
            var pieces = String(params.address).split(',');
            if (pieces.length > 0) { return pieces[pieces.length - 1].trim() }
          }
        } catch (e) { console.debug('extractCityFromParams failed', e) }
        return ''
      },

      // Remove geo page specific extras (title, breadcrumbs, descriptions, surrounding estates)
      removeGeoPagesExtenstions: function () {
        try {
          if (!document.body.classList.contains('geopages')) { return }

          // Keep only the results list in #estateoffer-list
          var listContainer = document.getElementById('estateoffer-list');
          if (listContainer) {
            Array.prototype.slice.call(listContainer.children).forEach(function (child) {
              if (!child.matches('#estateListHx')) {
                if (child && child.parentNode) {
                  child.parentNode.removeChild(child);
                }
              }
            });
          }

          // Remove any remaining geo intro blocks and breadcrumbs
          var introNodes = document.querySelectorAll('.geo-intro');
          introNodes.forEach(function (n) { if (n && n.parentNode) { n.parentNode.removeChild(n) } });

          var crumbs = document.querySelectorAll('ul.bc_geo');
          crumbs.forEach(function (el) { if (el && el.parentNode) { el.parentNode.removeChild(el) } });
        } catch (e) { console.debug('removeGeoPagesExtenstions failed', e) }
      },

      update_history: function(params, excluded=["csrfmiddlewaretoken","filtered_markers", "bounds", "llz", "broker_name"]){
        /**
         * Update url history state with new bounds
         * some parameters are excluded by default
         * **/
        const value_excluded = ["", [], null, undefined]
        const url = new URL(window.location);

        // Only leave the current (geo/landing) page for /zoeken/ when the
        // search actually changes page context: address-mode searches always
        // normalize to /zoeken/, everything else only when the landing page
        // rules armed a redirect (city changed, map-move search enabled,
        // shape drawn — see landing_page_redirect.js). Plain filter changes
        // search in place and keep the current URL (BPCOM-1695).
        var changedToZoeken = false;
        if (url.pathname !== '/zoeken/' && (params.search_mode === 'address' || triggerRedirect)) {
          url.pathname = '/zoeken/'
          changedToZoeken = true;
        }

        // Strip the geo-page extras (intro blocks, breadcrumbs) only when
        // actually redirecting away from the geo page.
        if (changedToZoeken) {
          bp.search.removeGeoPagesExtenstions();
        }
        for (const [key, value] of Object.entries(params)) {
          if (excluded.includes(key)) {
            continue;
          }
          // Drop cleared filter params (e.g. min_price after a tt switch) so
          // stale query-string values do not linger in the URL.
          if (value_excluded.includes(value)) {
            url.searchParams.delete(key);
          } else {
            url.searchParams.set(key, value);
          }
        }
        // BPCOM-1717: price is not used for "Te huur en te koop"; strip any
        // leftover price params even when omitted from the POST payload.
        if (String(params.tt) === '3') {
          url.searchParams.delete('min_price');
          url.searchParams.delete('max_price');
          url.searchParams.delete('price_type');
        }
        window.history.pushState({}, '', url);
      },


      // Clears city/address/search mode from state and URL on map movement.
      // Only called when map-move search is enabled (see the movementCheckbox
      // gate in maps.js): with the toggle off, panning must not touch the
      // search state; with it on, bounds take over from the city filter.
      clear_geo_selection: function () {
        try {
          // Clear hidden fields
          $('#id_cn').val('');
          $('#id_address').val('');
          $('#id_search_mode').val('');
          // Clear display field but do not trigger searches here
          $('#id_user_display').val('');

          // Update state only when state module is available
          if (bp.state && typeof bp.state.set === 'function') {
            bp.state.set('cn', '');
            bp.state.set('address', '');
            bp.state.set('search_mode', '');
          }

          // Remove from URL (keep other params intact)
          const url = new URL(window.location);
          url.searchParams.delete('cn');
          url.searchParams.delete('address');
          url.searchParams.delete('search_mode');
          window.history.replaceState({}, '', url);
        } catch (e) {
          console.debug('clear_geo_selection error', e)
        }
      },

      hx_search_pagination: function(page, vastgoed=null, event=null){
         /**
          * Ajax htmx based search,
          * triggered by pagination buttons on list view
         * **/
        if (event && typeof event.preventDefault === 'function') {
          event.preventDefault()
        }
        console.log('hx_search_pagination with state and page', page, bp.search.search_form_state())
         if(page === undefined){
           page = 1
         }

         if(window.searchHtmxInprogress === true){
            console.debug("search htmx in progress, preventing with current state", bp.search.search_form_state())
            return
          }
        $("#id_p").val(page)
        $("#search_data_modal #id_p").val(page)
        let data;
        data = bp.search.search_form_state()

        if(data.ups && Array.isArray(data.ups)){
          data.ups = data.ups.join(",")
        }
        // if url has provincie then add to data
        try{
          let provincie = window.location.pathname.split('/').filter(f=> f!=="")
            if(provincie && provincie.length > 0){
            if(provincie[0] === "provincie"){
                data.provincie = provincie[1]
                }
            }
        } catch (e){
          console.debug("error", e)
        }
        if (!vastgoed) {
          vastgoed = bp.search.get_vastgoed_slug();
        }
        if (vastgoed) {
          data.vgd = vastgoed;
        }
        const context = {
          target:'#estateListHx', swap:'innerHTML', values: data
        }
    
        try{
          _.debounce(htmx.ajax('POST', '/zoeken/' , context), 1500, true)
        } catch (e){
          console.debug("error", e)
        }
        bp.search.update_history(data)
      },

      hx_search: function (event){
         /**
          * Ajax htmx based search,
          * Triggered by search button
          * On desktop calls both map & list search
          * On mobile calls correct search based on what is visible
         * **/
         // prevent form submission (event may be a synthetic object from
         // auto-refresh, so guard preventDefault before calling it)
         if (event && typeof event.preventDefault === 'function') {
           event.preventDefault()
         }

         var fromAutoRefresh = !!(event && event.fromAutoRefresh === true);

         // if the search modal is open we need to close again
         // closing search modal will copy the modal search form data to the form.
         // On auto-refresh we keep the modal open so the user can keep tweaking.
          if($('#search-form-modal').hasClass('in') && !fromAutoRefresh){
            $('#search-form-modal').modal('hide');
          }

          bp.search.show_auto_refresh_indicator();

          console.debug("trigger search via button")

         if (bp.bootstrap.get_bootstrap_environment() === 'lg') {
            // on desktop, if no city specified we DONT jump
            // to llz, instead only jump when enter is clicked on city
            // see reset_listerners method

            // Refresh the list from the live form immediately. parseMarkerResults
            // used to be the only list trigger and skipped it while list_loaded
            // was still true (geo pages set that on init), so the first filter
            // change only updated the map snapshot.
            // load_markers first: getMarkersUrl synchronously refreshes
            // #id_bounds from the map, so the list request that follows
            // cannot use a stale, pre-pan viewport.
            bp.maps.load_markers(false, { skip_list_update: true });
            bp.search.hx_search_pagination(1, bp.search.get_vastgoed_slug());

          } else {
           // on mobile call list view is current view is list
            if(localStorage.view === 'list'){
              bp.search.hx_search_pagination(1, bp.search.get_vastgoed_slug())
            } else {
              if ($('.search-modal #id_cn').val() === '') {
                //bp.maps.jump_to_llz('52,5.8,7')
              }
              bp.maps.load_markers()
            }

          }
      },

      /**
       * Simple implementation of image lazy loading in plain js
       * Uses intersection observer to detect when image is view port
       * Includes fall back for non compatible browsers
       * https://css-tricks.com/the-complete-guide-to-lazy-loading-images/
       * **/
      lazy_load_images: function () {
        var lazyloadImages;
        if ("IntersectionObserver" in window) {
          lazyloadImages = document.querySelectorAll(".lazy");
          let desktop = bp.bootstrap.get_bootstrap_environment() === 'lg'
          var imageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                // Search-result cards are device-gated: each result renders a desktop and a
                // mobile .result-row, and we only load the variant for the current device so
                // we never download both. Images outside a .result-row (e.g. the detail-page
                // gallery) are not gated and must always load.
                let result_row = entry.target.closest('.result-row');
                let is_desktop_card = result_row ? result_row.classList.contains('desktop') : false;
                let is_mobile_card = result_row ? result_row.classList.contains('mobile') : false;
                let is_grid = entry.target.classList.contains('item-img-grid');

                // Fix for tablets: tablets see desktop containers but are classified as !desktop
                // Allow tablets (768px-1199px) to load desktop card images
                let tablet = window.innerWidth >= 768 && window.innerWidth < 1200;
                if(!result_row || desktop && is_desktop_card || !desktop && is_mobile_card || tablet && is_desktop_card || is_grid){
                    var image = entry.target;
                    image.src = image.dataset.src;
                    if (image.dataset.srcset !== undefined) {
                      image.srcset = image.dataset.srcset
                    }
                    image.classList.remove("lazy");
                    imageObserver.unobserve(image);
                }
              }
            });
          });

          lazyloadImages.forEach(function (image) {
            imageObserver.observe(image);
          });
        } else {
          var lazyloadThrottleTimeout;
          lazyloadImages = document.querySelectorAll(".lazy");

          function lazyload() {
            if (lazyloadThrottleTimeout) {
              clearTimeout(lazyloadThrottleTimeout);
            }

            lazyloadThrottleTimeout = setTimeout(function () {
              var scrollTop = window.pageYOffset;
              lazyloadImages.forEach(function (img) {
                if (img.offsetTop < (window.innerHeight + scrollTop)) {
                  img.src = img.dataset.src;
                  if (img.dataset.srcset !== undefined) {
                    img.srcset = img.dataset.srcset;
                  }

                  img.classList.remove('lazy');
                }
              });
              if (lazyloadImages.length === 0) {
                document.removeEventListener("scroll", lazyload);
                window.removeEventListener("resize", lazyload);
                window.removeEventListener("orientationChange", lazyload);
              }
            }, 20);
          }

          document.addEventListener("scroll", lazyload);
          window.addEventListener("resize", lazyload);
          window.addEventListener("orientationChange", lazyload);
        }
      },
      load_estateofffer_list_scroll_position: function () {
        console.debug("restoring search list position")
        if (typeof localStorage.scrollTop !== "undefined") {
          $('#search-results-list').scrollTop(localStorage.scrollTop);

          //reset this value everytime this method is called
          localStorage.removeItem('scrollTop');
        }


      },

      resolve_estate_url: function(el){
        var slug = el.getAttribute('data-slug');
        if(!slug){
          return null
        }
        var url = null
        try{
          var hide_address = el.getAttribute('data-hide-address');
          var esof_type = el.getAttribute('data-esof-type');
          var pk = el.getAttribute('data-pk');
          if (hide_address === 'True') { // python
              url = `/bedrijfspanden/${esof_type}/${pk}/`;
          } else {
              url = `/bedrijfspanden/${slug}/`;
          }
        } catch (e) {
          console.error(e)
          return null
        }
      }
    }
  })()
});

// BPCOM-1716: bind the filter auto-refresh listeners as soon as the DOM is
// ready. bp.search.init only runs after an /update_session_url/ ajax
// round-trip, so a filter change made before that (the user's very first
// interaction) was lost when binding happened inside reset_listeners only.
// The handlers are delegated and bind-once, so the later reset_listeners
// call is a no-op.
$(function () {
  if (document.getElementById('estateListHx') !== null) {
    bp.search.reset_listeners_for_auto_refresh_filters();
  }
});
